export const defaultTeacherPassword = 'Journey123!'
export const branchAPIKeyLive = 'key_live_ifTudqtRiCnbFAFtX8l3ejnhzwnpYpF3'
export const branchAPIKeyDev = 'key_live_jbNweTyTNJMUPPpyh7imEicmuznnDRGP'



// WEBPACK FOOTER //
// ./src/configs/appConfig.ts